import React, {useMemo} from "react";
import {Button} from "@mui/material";
import QuickOrderItemElement from "../quick-order-item-element";

export const OrderItems = ({
                               itemEntities,
                               customer,
                               addNewRow,
                               removeRow,
                               updateRow,
                               warehouses,
                               validatePartNo,
                               getAvailabilityForPartNo,
                               getPriceForCustomerAndPartNo,
                               onPartFirstValidated,
                               hasSuggestiveBeenOfferedForPart,
                               pricingSectionEnabled = false,
                           }) => {
    const existingPartNos = useMemo(() =>
        itemEntities
            .filter(e => !!e?.partNumber?.trim())
            .map(e => ({
                id: e.id,
                partNo: e.partNumber?.toUpperCase()?.trim(),
            }))
        ?? [], [itemEntities]);

    return (
        <>
            <div className={'quick-order-items-section'}>
                {
                    itemEntities.map((e, index, array) => (
                        <QuickOrderItemElement
                            key={e.id}
                            item={e}
                            isLast={index === (array.length - 1)}
                            canRemove={array.length > 1}
                            warehouses={warehouses}
                            existingPartNos={existingPartNos}
                            onRemove={removeRow}
                            onUpdate={updateRow}
                            addItemOnTabCallBack={addNewRow}
                            getAvailabilityForPartNo={getAvailabilityForPartNo}
                            validatePartNo={validatePartNo}
                            getPriceForCustomerAndPartNo={getPriceForCustomerAndPartNo}
                            selectedCustomer={customer}
                            pricingSectionEnabled={pricingSectionEnabled}
                            onPartFirstValidated={onPartFirstValidated}
                            hasSuggestiveBeenOfferedForPart={hasSuggestiveBeenOfferedForPart}
                        />
                    ))}
                <div className={'d-flex align-items-center justify-content-center'}>
                    <Button
                        className='my-3'
                        variant={'outlined'}
                        color={'primary'}
                        onClick={() => addNewRow(undefined, true)}
                    >
                        Click here or press Tab continuously to add new Rows
                    </Button>
                </div>
            </div>
        </>
    );
}